import React from 'react';
import reactDom from './react/dom/index';
import ImmaginiCorrelateContainer from '../components/common/ImmaginiCorrelateContainer';

export default function init() {
	reactDom(<ImmaginiCorrelateContainer />, 'js-react-imgsCorrelate');
}
